import { OrderFieldConfig } from '../../legacy-design-system/order'

export type ApplicationOrderField = 'NAME' | 'IMPORTANCE' | 'LANGUAGE'

export const orderFieldConfig: OrderFieldConfig<ApplicationOrderField> = {
  NAME: {
    direction: 'ASC',
    message: { id: 'title_name', defaultMessage: 'Name' }
  },
  IMPORTANCE: {
    direction: 'DESC',
    message: { id: 'title_importance_level', defaultMessage: 'Importance' }
  },
  LANGUAGE: {
    direction: 'ASC',
    message: { id: 'title_programmingLanguage', defaultMessage: 'Language' }
  }
}
